<section class="decision-pulse-strip" *ngIf="!loading && !error; else pulseState">
  <div class="decision-pulse-strip__status">
    <span class="decision-pulse-strip__dot" [attr.data-tone]="tone" aria-hidden="true"></span>
    <div class="decision-pulse-strip__copy">
      <p class="decision-pulse-strip__eyebrow">{{ lang.translate('home.decisionPulse.eyebrow') }}</p>
      <h2 class="decision-pulse-strip__headline">{{ headline }}</h2>
      <p class="decision-pulse-strip__support">{{ supportCopy }}</p>
    </div>
  </div>

  <output class="decision-pulse-strip__meta" *ngIf="connectionLabel" aria-live="polite">
    <span class="decision-pulse-strip__meta-label">{{ lang.translate('home.decisionPulse.connection.label') }}</span>
    <span class="decision-pulse-strip__meta-status">
      <span class="decision-pulse-strip__meta-dot" [attr.data-state]="connectionState" aria-hidden="true"></span>
      <span class="decision-pulse-strip__meta-value" [attr.data-state]="connectionState">{{ connectionLabel }}</span>
    </span>
  </output>
</section>

<ng-template #pulseState>
  <div class="decision-pulse-strip decision-pulse-strip--state" *ngIf="error; else pulseLoading">
    <p class="decision-pulse-strip__headline">{{ error.title }}</p>
    <p class="decision-pulse-strip__support">{{ error.message }}</p>
  </div>

  <ng-template #pulseLoading>
    <div class="decision-pulse-strip decision-pulse-strip--state" role="status">
      <p class="decision-pulse-strip__support">{{ lang.translate('home.general.loading') }}</p>
    </div>
  </ng-template>
</ng-template>